import React from "react";
import { Link } from "react-router-dom";
import { formatGBP } from "@/lib/format";

export default function ProductCard({ product, index = 0 }) {
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group cursor-pointer flex flex-col gap-4 animate-fade-up"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-secondary">
        <img
          src={product.image_url}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105 opacity-90 group-hover:opacity-100"
          loading="lazy"
        />
        {product.featured && (
          <div className="absolute top-3 left-3 border border-primary/60 text-primary bg-background/60 backdrop-blur-sm text-[10px] uppercase tracking-[0.24em] px-2 py-1">
            Featured
          </div>
        )}
      </div>
      <div className="flex flex-col gap-1">
        <div className="text-[10px] uppercase tracking-[0.24em] text-muted-foreground">
          {product.concentration} · {product.size_ml}ml
        </div>
        <div className="font-serif text-xl text-foreground transition-colors group-hover:text-primary leading-tight">
          {product.name}
        </div>
        <div className="font-sans text-sm tracking-wider text-muted-foreground mt-1">
          {formatGBP(product.price)}
        </div>
      </div>
    </Link>
  );
}
